import styled from "styled-components";

export const Container = styled.div`
  position: relative;

  input {
    padding-left: 2.5rem;
  }

  i {
    position: absolute;
    left: 0.4rem;
    top: 0.3rem;
    color: #fff;
  }
`;
